import { GeoCoordinates, FALLBACK_COORDINATES } from "@constants";

// Gets GeoCoordinates from 'Branches, Atms' search address
const getLocalStorageCoordinates = (localStorageKey: string): GeoCoordinates => {
  const parsedCoordinates: GeoCoordinates = JSON.parse(
    window.localStorage.getItem(localStorageKey)
  );

  return parsedCoordinates ?? FALLBACK_COORDINATES;
};

export default getLocalStorageCoordinates;
